import { forwardRef } from 'react'
import classNames from 'classnames'


const VARIANT_CLASSES = {
  'primary': 'bg-gradient-to-br from-primary to-main  text-white dark:text-black',
  'primary-light': 'dark:bg-dark-mode-header bg-light-mode-header',
  'secondary': 'bg-secondary text-white',
  'info': 'shadow-md dark:shadow-none dark:text-neutral-100 dark:bg-neutral-900',
  'danger': 'bg-red-600 text-white hover:opacity-90 dark:bg-red-500 dark:text-white',
  'disabled': 'bg-neutral-300 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-500',
}
const SIZE_CLASSES = {
  'sm': 'text-sm px-3 py-1.5 rounded-sm',
  'md': 'text-base px-4 py-2 rounded-md',
  'lg': 'text-xl px-5 py-3 rounded-xl font-bold',
}

let Button = forwardRef(({ children, variant, size, disabled, ...rest }, ref) => (
  <a
    {...rest}
    className={classNames(
      'cursor-pointer inline-flex items-center justify-center',
      VARIANT_CLASSES[disabled ? 'disabled' : variant],
      SIZE_CLASSES[size] || SIZE_CLASSES.md,
      rest.className
    )}
    ref={ref}
  >
    {children}
  </a>
))

export default Button
